import { RotateCwIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Portal } from '@air/primitive-portal';

export type ReloadApplicationPromptProps = {
  onReload: () => void;
};

export const ReloadApplicationPrompt = ({ onReload }: ReloadApplicationPromptProps) => {
  return (
    <Portal>
      <div className="absolute bottom-6 left-6 flex w-full max-w-[224px] flex-col gap-4 rounded-8 ads:bg-base bg-gray-1 p-4 shadow-popover">
        <header className="flex flex-col items-center">
          <div className="font-semibold ads:text-primary text-14 text-gray-12">Air has an update!</div>
          <div className="ads:text-metadata text-12 text-gray-10">Click to refresh.</div>
        </header>

        <footer className="flex flex-col items-stretch">
          <Button appearance="filled" color="blue" onClick={onReload} prefix={<RotateCwIcon size="sm" />}>
            Refresh now
          </Button>
        </footer>
      </div>
    </Portal>
  );
};
